import React from 'react';
import '../../../styles/modes/customMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Custom Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>

        <div className="help-text">
          <p><strong>Purpose:</strong> Manually create allocation plans for Transportation Problems by assigning shipment quantities from supply points (warehouses) to demand points (customers). Design your own distribution strategy based on domain knowledge.</p>

          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>Supply and demand points loaded in Setup Mode</li>
            <li>At least one supply point (warehouse) and one demand point (customer)</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Review Supply-Demand Balance:</strong>
              <ul>
                <li>Check total supply vs total demand displayed at top</li>
                <li>System alerts if unbalanced (supply ≠ demand)</li>
                <li>Can still create allocation even if unbalanced</li>
              </ul>
            </li>
            <li><strong>View Route Cards:</strong>
              <ul>
                <li>One card per supply point (warehouse)</li>
                <li>Each card shows warehouse capacity and remaining quantity</li>
                <li>Color-coded for easy identification</li>
              </ul>
            </li>
            <li><strong>Assign Customers to Routes:</strong>
              <ul>
                <li>Expand a warehouse card to see available customers</li>
                <li>Click on a customer to assign quantity</li>
                <li>Enter shipment quantity in the dialog</li>
                <li>Click "Assign" to confirm the allocation</li>
              </ul>
            </li>
            <li><strong>Manage Allocations:</strong>
              <ul>
                <li>View assigned customers in each warehouse card</li>
                <li>See allocated quantity and remaining capacity</li>
                <li>Click × to remove an allocation</li>
                <li>Reassign quantities as needed</li>
              </ul>
            </li>
            <li><strong>View and Confirm:</strong>
              <ul>
                <li>Check routes displayed on map with quantities</li>
                <li>Review total allocated quantities</li>
                <li>Click "Confirm Routes" to save allocation plan</li>
              </ul>
            </li>
          </ol>

          <p><strong>Allocation Interface:</strong></p>
          <ul>
            <li><strong>Supply Cards:</strong> One per warehouse (supply point)
              <ul>
                <li>Warehouse capacity</li>
                <li>Remaining quantity</li>
                <li>List of assigned customers</li>
              </ul>
            </li>
            <li><strong>Customer List:</strong> Shows available demand points
              <ul>
                <li>Customer demand requirement</li>
                <li>Remaining unmet demand</li>
                <li>Assignment status</li>
              </ul>
            </li>
            <li><strong>Quantity Dialog:</strong> Appears when assigning
              <ul>
                <li>Enter shipment quantity</li>
                <li>Cannot exceed warehouse remaining capacity</li>
                <li>Cannot exceed customer remaining demand</li>
              </ul>
            </li>
          </ul>

          <p><strong>Allocation Rules:</strong></p>
          <ul>
            <li>Each warehouse can serve multiple customers</li>
            <li>Each customer can receive from multiple warehouses</li>
            <li>Total allocated from warehouse ≤ warehouse capacity</li>
            <li>Total allocated to customer ≤ customer demand</li>
            <li>All quantities must be positive numbers</li>
          </ul>

          <p><strong>Visualization:</strong></p>
          <ul>
            <li><strong>Map Routes:</strong> Lines from warehouses to customers</li>
            <li><strong>Quantity Labels:</strong> Show allocated amounts on routes</li>
            <li><strong>Color Coding:</strong> Each warehouse route has unique color</li>
            <li><strong>Real-time Update:</strong> Routes update as allocations change</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Start by assigning largest demands first</li>
            <li>Consider distance when allocating (shorter = lower cost)</li>
            <li>Try to fully utilize warehouse capacities</li>
            <li>Ensure all customer demands are met if possible</li>
            <li>Click "Confirm Routes" to save for comparison</li>
            <li>System automatically calculates total cost based on distances</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip;
